import styled from "styled-components";

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10000;
  
  @media (max-width: ${({ theme }) => theme.breakpoint.miniMobile}px) {
    height: 100vh; /* fallback dla starszych przeglądarek */
    height: 100dvh; /* dynamic viewport height */
    max-height: 100dvh;
  }
`;

export const ModalContent = styled.div`
  background-color: #2d2d2d;
  padding: 40px;
  border-radius: 12px;
  width: 90%;
  max-width: 800px;
  height: 85vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
  
  @media (max-width: ${({ theme }) => theme.breakpoint.miniMobile}px) {
    width: 100%;
    height: 100vh; /* fallback dla starszych przeglądarek */
    height: 100dvh; /* dynamic viewport height */
    max-height: 100dvh;
    border-radius: 0;
    padding: 4px;
  }
`;

export const ModalHeader = styled.h2`
  text-align: center;
  margin-bottom: 24px;
  color: #ffffff;
  font-size: 28px;
`;

export const RegulationsContainer = styled.div`
  overflow-y: auto;
  flex-grow: 1;
  padding-right: 20px;
  margin-bottom: 24px;
  color: #2d2d2d;

  &::-webkit-scrollbar {
    width: 8px;
  }
  &::-webkit-scrollbar-track {
    background: #444;
    border-radius: 4px;
  }
  &::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 4px;
  }
  &::-webkit-scrollbar-thumb:hover {
    background: #aaa;
  }
  
  @media (max-width: ${({ theme }) => theme.breakpoint.miniMobile}px) {
    padding-right: 0;
    margin-right: 0;
    
    /* Przesuń suwak bardziej na prawo i zrób go węższy */
    &::-webkit-scrollbar {
      width: 4px;
    }
    
    /* Alternatywnie - ukryj suwak na mobilnych */
    /* &::-webkit-scrollbar {
      display: none;
    }
    -ms-overflow-style: none;
    scrollbar-width: none; */
  }
`;

export const AcceptButton = styled.button`
  background-color: #4caf50;
  color: white;
  padding: 14px 20px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  width: 100%;
  font-size: 18px;
  font-weight: 600;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #45a049;
  }

  &:disabled {
    background-color: #666;
    cursor: not-allowed;
  }
`;
